import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { cardBlockAnchorStyles } from './styles/card-block-anchor.styles';
import type { CardBlockAnchorPropsInterface } from './types/card-block-anchor.types';

/**
 * @since 10.0.0
 */
export const CardBlockAnchor = forwardRef<HTMLAnchorElement, CardBlockAnchorPropsInterface>(
  (props: CardBlockAnchorPropsInterface, forwardedRef) => {
    const { asChild = false, children, className, css: cssProp, ...rest } = props;

    const styles = css(cardBlockAnchorStyles, cssProp);
    const Component = asChild ? Slot : 'a';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Card.BlockAnchor"
        className={cx('c11n', styles, className)}
        tabIndex={-1}
        aria-hidden
        {...rest}
      >
        {asChild ? children : '\u00A0'}
      </Component>
    );
  },
);

CardBlockAnchor.displayName = 'Card.BlockAnchor';
